export class ThemeService {
  private submissionStateChipClass: Record<string, string> = {
    gray: 'border-gray-300 text-gray-700 bg-gray-100',
    blue: 'border-blue-300 text-blue-700 bg-blue-100',
    red: 'border-red-300 text-red-700 bg-red-100',
    emerald: 'border-emerald-300 text-emerald-700 bg-emerald-100',
    yellow: 'border-yellow-300 text-yellow-700 bg-yellow-100',
  };

  getSubmissionStateChipClass(color: string): string {
    if (color in this.submissionStateChipClass) {
      return this.submissionStateChipClass[color];
    } else {
      return '';
    }
  }
}
